import React, { forwardRef, useMemo } from "react";
import {
  NavigationContainer,
  DarkTheme,
  DefaultTheme,
} from "@react-navigation/native";
import { useTheme } from "../context/ThemeContext";

/**
 * NavigationContainer wired to the app's ThemeContext so the bg behind the
 * shell stays dark (instead of the default React-Navigation white).
 */
const ThemedNavigationContainer = forwardRef(function ThemedNavigationContainer(
  { children, ...rest },
  ref,
) {
  const { theme, mode } = useTheme();
  const navTheme = useMemo(() => {
    const base = mode === "dark" ? DarkTheme : DefaultTheme;
    return {
      ...base,
      dark: mode === "dark",
      colors: {
        ...base.colors,
        background: theme.bg,
        card: theme.surface,
        text: theme.text,
        border: theme.border,
        primary: theme.brand,
        notification: theme.brand2,
      },
    };
  }, [mode, theme]);

  return (
    <NavigationContainer ref={ref} theme={navTheme} {...rest}>
      {children}
    </NavigationContainer>
  );
});

export default ThemedNavigationContainer;
